/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useValueProposition } from 'bundles/browse-common/contexts/ValuePropositionContext';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

const ValuePropositionMetatags = () => {
  const valuePropositionContext = useValueProposition();
  if (!valuePropositionContext) {
    return null;
  }

  return (
    <CourseraMetatags
      metaNameAndProperties={{
        title: valuePropositionContext.title,
        description: valuePropositionContext.description ?? undefined,
      }}
    />
  );
};

export default ValuePropositionMetatags;
